import React, { useState, useEffect } from "react";
import { fetchFiles } from "../Utility/Storage/storageUtils";
import { retrieveMineData } from "../Utility/ConsumeToken/consumeToken";
import { getFileDeep, deleteFiles, renameFiles } from "../Utility/ManageFiles/fileUtils";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import Output from "../components/outputStorage";
import { sortFilesByDate } from '../Utility/Storage/storageUtils';

function ExtractEdgeStorage() {
    const [files, setFiles] = useState([]);
    const [nameFilter, setNameFilter] = useState("");
    const [dateFilter, setDateFilter] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [showFeatureModal, setShowFeatureModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        async function loadFiles() {
            try {
                const apitoken = await retrieveMineData();
                const fileList = await fetchFiles(apitoken._id, "DEEPSAGE_SCRAPER");
                console.log("File ricevuti:", fileList);
                setFiles(fileList);
            } catch (error) {
                console.error("Errore nel caricamento dei file:", error);
            } finally {
                setIsLoading(false);
            }
        }
        loadFiles();
    }, []);

    const handleNameFilterChange = (event) => {
        setNameFilter(event.target.value);
    };

    const handleDateFilterChange = (event) => {
        setDateFilter(event.target.value);
    };

    const filteredFiles = files.filter((file) => {
        const matchesName = file.filename.toLowerCase().includes(nameFilter.toLowerCase());
        const matchesDate = dateFilter ? file.date === dateFilter : true;
        return matchesName && matchesDate;
    });

    const handleDownload = async (fileName) => {
        try {
            const apitoken = await retrieveMineData();
            const fileData = await getFileDeep("DEEPSAGE_SCRAPER", fileName, apitoken);
            const blob = new Blob([fileData.output], { type: "application/octet-stream" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleUseFeature = (fileName) => {
        setSelectedFile(fileName);
        setShowFeatureModal(true);
    };

    const handleSendToFeature = async (feature) => {
        if (!selectedFile) return;
        try {
            const apitoken = await retrieveMineData();
            const fileData = await getFileDeep("DEEPSAGE_SCRAPER", selectedFile, apitoken);
            let pipelineData;
            try {
                pipelineData = JSON.parse(fileData.output);
            } catch (e) {
                pipelineData = fileData.output;
            }
            setShowFeatureModal(false);
            if (feature === "Deepsage") {
                navigate("/deepsage", { state: { params: { pipelineData } } });
            } else if (feature === "Graph") {
                navigate("/graph", { state: { params: { pipelineData } } });
            }
        } catch (error) {
            console.error("Error sending file to feature:", error);
        }
    };

    const deleteScrape = async (fileName) => {
        try {
            const apitoken = await retrieveMineData();
            const GID = fileName.replace(".json", "");
            await deleteFiles(apitoken._id, "DEEPSAGE_SCRAPER", GID);
            alert("File deleted successfully.");
            window.location.reload();
        } catch (error) {
            console.error("Errore nel visualizzare il report", error);
        }
    };

    const renameScrape = async (fileName, newName) => {
        try {
            const apitoken = await retrieveMineData();
            const GID = fileName.replace(".json", "");
            await renameFiles(apitoken._id, "DEEPSAGE_SCRAPER", GID, newName);
            alert("File renamed successfully.");
            window.location.reload();
        } catch (error) {
            console.error("Errore nel visualizzare il report", error);
        }
    };

    const sortedFiles = sortFilesByDate(filteredFiles, 'desc');

    return (
        <>
            <Header />
            <div className="riga headerStorage">
                <h3 className="titolo titoloManage noMarginBottom">EXTRACTEDGE STORAGE</h3>
                <span className="description text">
                    Here, you can access and review all output files generated by our ExtractEdge tool. These files are organized and cataloged for your convenience, making it easy to locate and reuse data across various tools within the platform.
                </span>
                <div className="space"></div>
                <div className="div50">
                    <label>Search by Name:</label>
                    <input
                        className="searchOutput"
                        type="text"
                        placeholder="Search for a specific SCRAPE by typing it here...."
                        value={nameFilter}
                        onChange={handleNameFilterChange}
                    />
                </div>
                <div className="div50">
                    <label>Filter by Date:</label>
                    <input
                        type="date"
                        value={dateFilter}
                        onChange={handleDateFilterChange}
                    />
                </div>

                <div className="space"></div>
                <hr />
            </div>
            <div className="riga space-bottom bodyStorage">
                {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    <>
                        <div>
                            {sortedFiles.length === 0 ? (
                                <p>Files not found</p>
                            ) : (
                                sortedFiles.map((file, index) => (
                                    <Output
                                        key={index}
                                        name={file.filename}
                                        date={file.date}
                                        download={() => handleDownload(file.filename)}
                                        textAction="Use in a Tool"
                                        action={() => handleUseFeature(file.filename)}
                                        deleteFile={() => deleteScrape(file.filename)}
                                        renameFile={(newName) => renameScrape(file.filename, newName)}
                                    />
                                ))
                            )}
                        </div>
                        <div className="spaceGraph"></div>
                        <div className="spaceGraph"></div>
                        <div className="spaceGraph"></div>
                    </>
                )}
            </div>
            {showFeatureModal && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <div className="divCloseButton">
                            <button onClick={() => setShowFeatureModal(false)} className="CloseButton text">
                                X
                            </button>
                        </div>
                        <p>For which Tool do you want to use this scrape?</p>
                        <div className="chooseFeature">
                            <button
                                className="buttonUser button"
                                onClick={() => handleSendToFeature("Deepsage")}
                            >
                                Deepsage
                            </button>
                            <p>or</p>
                            <button
                                className="buttonUser button"
                                onClick={() => handleSendToFeature("Graph")}
                            >
                                Graph
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ExtractEdgeStorage;
